import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./OrganizationInfo.css";

const OrganizationInfo = () => {
    return (
        <Container className="organization-info">
            <Row>
                <Col md={12}>
                    <h2 style={{ color: '#2E7D32' }}>Pruthvisangram Gramvikas Sanstha</h2>
                    <p>
                        Pruthvisangram Gramvikas Sanstha (PSGS), based in Kadepur, District Sangli, Maharashtra, is a
                        dedicated non-governmental organization (NGO) committed to fostering sustainable rural development.
                        Founded in 2003, PSGS as a grassroots voluntary organization dedicated to empowering marginalized
                        communities especially women, youth and farmers. Over the years, it has grown into a vibrant force for
                        change, reaching more than 3869 villages across 13 districts of Maharashtra. Through its integrated
                        initiatives in agriculture, livelihoods, environment, water, sanitation and gender equality, PSGS continues
                        to strengthen community resilience and drive inclusive rural development.
                    </p>
                    <p>
                        By collaborating with government agencies, UNDP, Corporate Social Responsibility (CSR) partners and
                        local Gram Panchayats, PSGS has executed over 70 projects in the past 18 years, impacting more than
                        10,000 beneficiaries annually.
                    </p>
                    <p>
                        Since its inception in, PSGS has functioned as a grassroots NGO specializing in integrated rural
                        development, evolving from foundational community mobilization to large-scale, government-aligned
                        interventions. PSGS functions as a multifaceted organization, simultaneously serving as a technical
                        service provider, a project implementation agency, and a training and capacity-building institution.
                    </p>
                    <p>
                        With a core team of 13 professionals and a network of 48 subject matter experts specializing in water,
                        sanitation, environment, and gender, PSGS has evolved into a trusted, people-centered organization
                        dedicated to driving inclusive social development among vulnerable communities. Guided by its four
                        thematic pillars—women's empowerment, water conservation and sanitation, sustainable agriculture,
                        and environmental sustainability—PSGS continues to deliver impactful, community-driven solutions that
                        foster resilience and long-term well-being.
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default OrganizationInfo;
